// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b4c7288","552":"1a161db1","861":"a9cafda7"}[chunkId] + ".chunk.js";
};